// extracted by mini-css-extract-plugin
module.exports = {"bb-focus-area":"bb-focus-area___HCjz"};